import React from 'react';
import {
  Title,
  Grid,
  Col,
  Button,
  Card,
  CardHeader,
  CardContent,
  Icon,
} from '@common/components';
import {
  faEnvelope,
  faKey,
  faUser,
  faAdd,
} from '@fortawesome/free-solid-svg-icons';
import buttonClasses from './ButtonSampleView.module.scss';

export default function ButtonSampleView() {
  const variants = ['normal', 'flat', 'raised', 'outline'];
  const colors = ['primary', 'secondary', 'accent', 'warning', 'error'];
  const handleClick = (color, variant) => {
    return `Color: ${color} - Variant: ${variant}`;
  };
  return (
    <div className={buttonClasses.grid}>
      <Title type="h1">Button demo</Title>
      {colors.map((color) => (
        <Card className={buttonClasses.section} key={`grid_${color}`}>
          <CardHeader>
            {' '}
            <Title type="h3">Color {color}</Title>
          </CardHeader>
          <CardContent>
            <Grid>
              {variants.map((variant) => (
                <Col
                  flex
                  justify="center"
                  key={`col_${color}_${variant}`}
                  xs={6}
                  sm={3}
                >
                  <Button
                    onClick={() => handleClick(color, variant)}
                    variant={variant}
                    color={color}
                  >
                    Button {variant}
                  </Button>
                </Col>
              ))}
            </Grid>
          </CardContent>
        </Card>
      ))}
      <Card className={buttonClasses.section}>
        <CardHeader>
          <Title type="h3">Icons</Title>
        </CardHeader>
        <CardContent>
          <Grid>
            <Col flex justify="center" xs={6} sm={3}>
              <Button color="primary" prefix={<Icon icon={faAdd} />}>
                Button prefix icon
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={3}>
              <Button
                variant="flat"
                color="primary"
                suffix={<Icon icon={faKey} />}
              >
                Button sufix icon
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={3}>
              <Button
                variant="flat"
                color="warning"
                prefix={<Icon icon={faEnvelope} />}
              >
                Button prefix icon
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={3}>
              <Button
                variant="outline"
                color="accent"
                suffix={<Icon icon={faUser} />}
              >
                Button sufix icon
              </Button>
            </Col>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
